// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__13mPe","item":"PaymentsMobile_item__2wrHT","label":"PaymentsMobile_label__AdjOR","amount":"PaymentsMobile_amount__29gbB"};